import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShieldsDotIoComponent } from './simple-icons-shields-dot-io.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShieldsDotIoComponent ],
    exports:      [ SimpleIconsShieldsDotIoComponent ],
    bootstrap:    []
})
export class SimpleIconsShieldsDotIoModule {}
